import axios from "axios";
import mainConfig from "@/main.config";

export function GET(url: string) {
  return axios.get(mainConfig.CMS_BASE_URL + '/api' + url);
}
